<template>
	<div class="widget-card">
		<h2 v-if="widget" class="text-center">{{ widget.dashboardwidgets_title }}</h2>

		<LoadingSpinner v-if="loading" />
		<table v-else class="table table-sm table-bordered">
			<thead>
				<tr>
					<th>{{ $t('cards.widget.pension_type') }}</th>
					<th>{{ $t('cards.widget.pension_count') }}</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="row in rows" :key="row.pension_id">
					<td>{{ row.label }}</td>
					<td class="text-center">{{ row.value }}</td>
				</tr>
				<tr>
					<td><strong>{{ $t('cards.widget.pension_total') }}</strong></td>
					<td class="text-center"><strong>{{ total }}</strong></td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script type="text/javascript">
import DashboardMixin from '@/mixins/Dashboard.js'

export default {
	name: 'WidgetHorsePension',
	mixins: [DashboardMixin],
	props: ['widget'],
	data() {
		return {
			loading: true,
			rows: [],
			total: 0,
		}
	},

	mounted() {
		this.loadData()
	},

	methods: {
		async loadData() {
			this.loading = true
			const res = await this.getHorsePensionStats()
			this.rows = res.rows
			this.total = res.total
			this.loading = false
		},
	},

	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
	},
}
</script>
